import React from 'react'
import { Wrapper, Item } from './style'

const Footer = () =>
  <Wrapper>
    <Item position='left'>
      Nausicaa
    </Item>
    <Item position='right'>
      <span>P.I. 03671100984&nbsp;-&nbsp;</span>
      
      <a target="_blank" rel="noopener noreferrer" href='https://github.com/nausicaa/nausicaa.com.au'>Source code</a>
    </Item>
  </Wrapper>

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js